import { inject, Injectable } from '@angular/core';
import { ApiService } from 'src/app/abstract-classes/api.service/api.service';
import { ProfileGroup } from 'src/app/interfaces/profile-group';
import { ProfileGroupsProviderService } from 'src/app/providers/profile-groups/profile-groups.provider.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileGroupsService extends ApiService<ProfileGroup, ProfileGroupsProviderService> {
  private profileGroupsProviderService = inject(ProfileGroupsProviderService);
  protected override get provider(): ProfileGroupsProviderService {
    return this.profileGroupsProviderService;
  }
}
